/* © Clickroad — Carousel Produit */
(function () {
  var STYLE_ID = "clickroad-carousel-product-style";

  var CSS = "/* © Clickroad — Carousel Produit */\n" +
    ".cr-carousel{--visible:3;--gap:16px;--img-width:320px;--img-radius:16px;--img-border:0px;--img-border-color:#000;--btn-radius:12px;--btn-border:0px;--btn-border-color:#000;--btn-font-size:16px;--btn-color:#2948f2;--btn-text:#fff;--btn-font:Inter, system-ui, sans-serif;--btn-weight:600;--arrow-color:#0f172a;--arrow-size:40px;}\n" +
    ".cr-carousel{display:flex;flex-direction:column;align-items:center;min-width:0;max-width:100%;}\n" +
    ".cr-viewport{overflow:hidden;max-width:100%;width:100%;}\n" +
    ".cr-track{display:flex;gap:var(--gap);transition:transform .35s ease;will-change:transform;}\n" +
    ".cr-card{display:flex;flex-direction:column;align-items:center;gap:12px;min-width:0;flex:0 0 calc((100% - (var(--visible) - 1)*var(--gap))/var(--visible));width:calc((100% - (var(--visible) - 1)*var(--gap))/var(--visible));}\n" +
    ".cr-card img{width:var(--img-width);max-width:100%;height:auto;border-radius:var(--img-radius);border:var(--img-border) solid var(--img-border-color);object-fit:contain;background:#f7f7f9;}\n" +
    ".cr-cta{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 16px;border-radius:var(--btn-radius);border:var(--btn-border) solid var(--btn-border-color);background:var(--btn-color)!important;color:var(--btn-text)!important;-webkit-text-fill-color:var(--btn-text)!important;font-size:var(--btn-font-size);font-family:var(--btn-font);font-weight:var(--btn-weight);text-decoration:none!important;transition:transform .2s ease,filter .2s ease,box-shadow .2s ease,opacity .2s ease;width:100%;max-width:var(--img-width);box-sizing:border-box;text-align:center;white-space:normal;}\n" +
    ".cr-cta:visited,.cr-cta:hover,.cr-cta:active,.cr-cta:focus{color:var(--btn-text)!important;-webkit-text-fill-color:var(--btn-text)!important;text-decoration:none!important;}\n" +
    ".cr-cta.disabled{opacity:.7;filter:grayscale(.2);}\n" +
    ".cr-cta.effect-darken:hover{filter:brightness(.9);}\n" +
    ".cr-cta.effect-lighten:hover{filter:brightness(1.08);}\n" +
    ".cr-cta.effect-zoom:hover{transform:scale(1.03);box-shadow:0 12px 26px rgba(0,0,0,0.12);}\n" +
    ".cr-cta.effect-none:hover{filter:none;transform:none;}\n" +
    ".cr-arrows{display:flex;gap:12px;justify-content:center;align-items:center;margin-top:10px;}\n" +
    ".cr-arrows button{border:none;background:transparent;color:var(--arrow-color);padding:6px 10px;cursor:pointer;font-size:var(--arrow-size);line-height:1;width:auto;height:auto;border-radius:0;}\n" +
    ".cr-arrows button:disabled{opacity:.35;cursor:not-allowed;}\n";

  function injectCss() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function num(v, d) {
    v = parseFloat(v);
    return isFinite(v) ? v : d;
  }

  function setVars(el) {
    var d = el.dataset;

    el.style.setProperty("--visible", String(Math.max(1, parseInt(d.visible || "3", 10) || 3)));
    el.style.setProperty("--gap", num(d.gap, 16) + "px");

    el.style.setProperty("--img-width", num(d.imgWidth, 320) + "px");
    el.style.setProperty("--img-radius", num(d.imgRadius, 16) + "px");
    el.style.setProperty("--img-border", num(d.imgBorder, 0) + "px");
    el.style.setProperty("--img-border-color", d.imgBorderColor || "#000");

    el.style.setProperty("--btn-radius", num(d.btnRadius, 12) + "px");
    el.style.setProperty("--btn-border", num(d.btnBorder, 0) + "px");
    el.style.setProperty("--btn-border-color", d.btnBorderColor || "#000");
    el.style.setProperty("--btn-font-size", num(d.btnFontSize, 16) + "px");
    el.style.setProperty("--btn-color", d.btnColor || "#2948f2");
    el.style.setProperty("--btn-text", d.btnText || "#fff");
    el.style.setProperty("--btn-font", d.btnFont || "Inter, system-ui, sans-serif");
    el.style.setProperty("--btn-weight", d.btnWeight || "600");

    el.style.setProperty("--arrow-color", d.arrowColor || "#0f172a");
    el.style.setProperty("--arrow-size", num(d.arrowSize, 40) + "px");
  }

  function init(el) {
    setVars(el);

    var viewport = el.querySelector(".cr-viewport");
    var track = el.querySelector(".cr-track");
    var arrows = el.querySelector(".cr-arrows");
    var prev = el.querySelector(".cr-prev");
    var next = el.querySelector(".cr-next");

    if (!viewport || !track || !arrows || !prev || !next) return null;

    var index = 0;

    function getVisible() {
      var v = parseInt(getComputedStyle(el).getPropertyValue("--visible"), 10);
      return isFinite(v) && v > 0 ? v : 1;
    }

    function getGap() {
      var g = getComputedStyle(track).gap;
      var px = parseFloat(g);
      return isFinite(px) ? px : 16;
    }

    function update() {
      setVars(el);

      var visible = getVisible();
      var gap = getGap();
      var items = track.children;

      var w = Math.max(0, viewport.clientWidth || el.clientWidth || 0);
      if (!w) {
        track.style.transform = "translateX(0px)";
        return;
      }

      var cardW = Math.floor((w - gap * Math.max(0, visible - 1)) / visible);
      if (!isFinite(cardW) || cardW <= 0) cardW = 1;

      for (var i = 0; i < items.length; i++) {
        items[i].style.width = cardW + "px";
        items[i].style.flex = "0 0 " + cardW + "px";
      }

      var need = items.length > visible;
      arrows.style.display = need ? "flex" : "none";

      if (!need) {
        index = 0;
        track.style.transform = "translateX(0px)";
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      var max = Math.max(0, items.length - visible);
      if (index > max) index = max;

      var step = cardW + gap;
      track.style.transform = "translateX(-" + index * step + "px)";
      prev.disabled = index === 0;
      next.disabled = index >= max;
    }

    prev.addEventListener("click", function () {
      index = Math.max(0, index - 1);
      update();
    });

    next.addEventListener("click", function () {
      var visible = getVisible();
      var max = Math.max(0, track.children.length - visible);
      index = Math.min(max, index + 1);
      update();
    });

    if ("ResizeObserver" in window) {
      var ro = new ResizeObserver(function () {
        update();
      });
      ro.observe(viewport);
    } else {
      window.addEventListener("resize", update);
    }

    update();
    return update;
  }

  function boot() {
    injectCss();

    var els = document.querySelectorAll(".cr-carousel");
    var ups = [];

    for (var i = 0; i < els.length; i++) {
      var u = init(els[i]);
      if (u) ups.push(u);
    }

    if (ups.length && !("ResizeObserver" in window)) {
      var raf = 0;
      window.addEventListener("resize", function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          for (var i = 0; i < ups.length; i++) ups[i]();
        });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();